import { DataSource } from '@angular/cdk/table';
import { CollectionViewer } from '@angular/cdk/collections';
import { Observable, BehaviorSubject, of } from "rxjs";
import { catchError, finalize } from "rxjs/operators";
import { DashboardService } from './dashboard.service';
import { PaginationTaskResponse, Task } from '../models/taskModel';
import { MatPaginator } from '@angular/material/paginator';
import { Sort } from '@angular/material/sort';

export class TaskDataSource implements DataSource<Task>{
    public meetingSubject = new BehaviorSubject<Task[]>([]);
    private loadingSubject = new BehaviorSubject<boolean>(false);
    private countSubject = new BehaviorSubject<number>(0);
    public counter$ = this.countSubject.asObservable();
    public loading$ = this.loadingSubject.asObservable();
    public totalCount:any;
    constructor(private dashboardService: DashboardService) { }
    
    connect(collectionViewer: CollectionViewer): Observable<Task[]> {
        return this.meetingSubject.asObservable();
    }

    disconnect(collectionViewer: CollectionViewer): void {
    this.meetingSubject.complete();
        this.loadingSubject.complete();
        this.countSubject.complete();
        
    }
    
      
    loadTasks(jsonReq:any) {
        this.loadingSubject.next(true);
        this.dashboardService.loadTasks(jsonReq)
            .pipe(
                catchError(() => of([])),
                finalize(() => this.loadingSubject.next(false))
            )
            .subscribe((result: PaginationTaskResponse) => {
                this.meetingSubject.next(result.dataList);
                this.countSubject.next(result.totalCount);
                this.totalCount=result.totalCount;
            });
    }
    loadSearchTasks(jsonReq:any) {
        this.loadingSubject.next(true);
        this.dashboardService.searchTasks(jsonReq)
            .pipe(
                catchError(() => of([])),
                finalize(() => this.loadingSubject.next(false))
            )
            .subscribe((result: PaginationTaskResponse) => {
                this.meetingSubject.next(result.dataList);
                this.countSubject.next(result.totalCount);
                this.totalCount=result.totalCount;
            });
    }
    
}